import { Component, OnInit, Input } from "@angular/core";
import { DialogService } from "ng2-bootstrap-modal";
import { IMyDpOptions } from "mydatepicker";
import { BulkRenewal, BulkRenewalRequest, Comite, UsuarioComite } from "../bulk-renewal.model";
import { BulkRenewalService } from "./service/bulk-renewal.service";
import { FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { saveAs } from "file-saver";
import * as moment from 'moment';
import 'moment/locale/pt-br';

@Component({
	selector: "app-bulk-renewal",
	templateUrl: "./bulk-renewal.component.html",
	styleUrls: ["./bulk-renewal.component.scss"],
	providers: [BulkRenewalService]
})
export class BulkRenewalComponent implements OnInit {
	@Input('proposalID') proposalID: string = "";
	@Input('isEditable') isEditable: boolean = true;
	
	public userID;
	public approvalStatus: string = "";
	public approvalMessage: string = "";
	public selectedLine: number = null;

	public proposalInfo: BulkRenewal = null;

	public comiteInfo: Array<Comite> = null;

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	//public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/\w/, /\w/, '.',/\w/, /\w/, /\w/, '.',/\w/, /\w/, /\w/, '/',/\w/, /\w/, /\w/, /\w/, '-',/\w/, /\w/];

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//height: "30px"
		
	};

    public faturamentoColumns: { titulo: string; propriedade: string; tipo: string }[] = [];
	
	constructor(
		private bulkRenewService: BulkRenewalService,
		private fb: FormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private flashMessagesService: FlashMessagesService,
		private dialogService: DialogService
	) { }

	ngOnInit() {
		
		if (this.proposalID == "") {
			this.proposalID = this.route.snapshot.params["guid"];
		}

		this.userID = localStorage.getItem("yara.userID");

		if (this.proposalID) {
			this.getProposalDetails();
			this.getComiteDetails();
			
		}
	}
 
	mask(): any {
		return {
			mask: value => {
				value = value.replace(/[^a-zA-Z0-9]+/g, '');
				if (value.length < 12) return this.cpfMask;
				else return this.cnpjMask;
			}
		};
	}

	getProposalDetails() {
		this.bulkRenewService.getProposal(this.proposalID).subscribe(
			result => {
				if (result.Success) {
					this.proposalInfo = result.Result;
	
					if   (this.proposalInfo && this.proposalInfo.DataCriacao)  {
						// Extrai o ano da data de criação
						const creationYear = new Date(this.proposalInfo.DataCriacao).getFullYear();
	
						// Gera as colunas com base no ano da data de criação
						this.generateFaturamentoColumns(creationYear);
					}
				}
			},
			error => {
				console.log(error);
			}
		);
	}

	generateFaturamentoColumns(baseYear: number) {
		this.faturamentoColumns = [];

		for (let i = 0; i < 4; i++) {
			const year = baseYear - i;

			this.faturamentoColumns.push({ titulo: `Faturamento Total ${year}`, propriedade: `FaturamentoTotal${i}`, tipo: 'Number' });
			this.faturamentoColumns.push({ titulo: `Faturamento a Prazo ${year}`, propriedade: `FaturamentoPrazo${i}`, tipo: 'Number' });
			this.faturamentoColumns.push({ titulo: `Atraso ${year}`, propriedade: `DiasAtraso${i}`, tipo: '' });
			this.faturamentoColumns.push({ titulo: `Prorrogação ${year}`, propriedade: `Prorrogacao${i}`, tipo: 'Boolean' });
		}
	}	

	getComiteDetails() {
		this.bulkRenewService.getCommittee(this.proposalID).subscribe(
			result => {
				if (result.Success) {
					this.comiteInfo = result.Result;
					console.log(this.comiteInfo);
				}
			},
			error => {
				console.log(error);
			}
		);
	}

	exportExcel() {
		this.bulkRenewService.exportExcel(this.proposalID).subscribe(
			result => {
				if (result) {
					const year = moment(this.proposalInfo.DataCriacao).format("YYYY");

					const proposta = this.proposalInfo.NumeroInternoProposta;

					saveAs(result, `Clientes_Renovacao_Proposta_RV_${proposta}_${year}.xlsx`);

					this.flashMessagesService.show("Exportação realizada com sucesso!", { cssClass: "alert-success", timeout: 6000 });
				} else {
					this.flashMessagesService.show("Exportação falhou!", { cssClass: "alert-danger", timeout: 6000 });
				}
			},
			error => {
				console.log(error);
			}
		);
	}

	sendToCommittee() {
		this.bulkRenewService.sendCommittee(this.proposalID).subscribe(
			result => {
				if (result.Success) {
					this.flashMessagesService.show("Proposta de Renovação de Vigência de LC enviada para comitê!", { cssClass: "alert-success", timeout: 6000 });

					this.getProposalDetails();
					this.getComiteDetails();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: "alert-danger", timeout: 6000  });
				}
			},
			error => {
				console.log(error);
			}
		);
	}

	saveApproval() {
		if (this.approvalStatus != "") {
			const approvalData = {
				PropostaRenovacaoVigenciaLCComiteID: this.comiteInfo[this.selectedLine].ID,
				Comentario: this.approvalMessage,
				StatusComiteID: this.approvalStatus
			};

			console.log(approvalData);

			this.bulkRenewService.setApproval(this.comiteInfo[this.selectedLine].ID, approvalData).subscribe(
				result => {
					if (result.Success) {
						this.flashMessagesService.show("Aprovação realizada com sucesso!.", { cssClass: "alert-success", timeout: 6000 });

						this.approvalMessage = '';
						this.approvalStatus = '';
						
						this.getProposalDetails();
						this.getComiteDetails();
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: "alert-danger", timeout: 6000  });
					}
				},
				error => {
					console.log(error);
				}
			);
		} else {
			this.flashMessagesService.show("Selecione um status de aprovação para prosseguir!.", { cssClass: "alert-danger", timeout: 6000 });
		}
	}

	cancelProposal() {
		this.bulkRenewService.cancelProposal(this.proposalID).subscribe(
			result => {
				if (result.Success) {
					this.flashMessagesService.show("Proposta cancelada com sucesso!.", { cssClass: "alert-success", timeout: 6000 });
					this.router.navigateByUrl('/cockpit');
				}
				else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			},
			error => {
				console.log(error);
			}
		);
	}

}



// WEBPACK FOOTER //
// ./src/app/bulk-renewal/component/bulk-renewal/bulk-renewal.component.ts